module.exports = __webpack_public_path__ + "0d0d4fa478cdf21ef8d525885c1aae34.pdf";